import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'

export const useEcusStore = defineStore('ecus', () => {

    const configStore   = useConfigStore()
    const requestsStore = useRequestsStore()
    const tokenStore    = useTokenStore()

    const ecus = ref({

        GNSS: {

            info: {

                calibration: null,
                fullName: 'Global Navigation Satellite System',
                fw: null,
                hw: null,
                mileage: null,
                name: 'GNSS',
                sn: null,
                soft: null,
                timeStamp: null,
                vin: null
            },

            report: {

                status: null,
                val: []
            },

            installed: false
        },

        ECM : {

            info: {

                calibration: null,
                fullName: 'Engine Control Module',
                fw: null,
                hw: null,
                mileage: null,
                name: 'ECM',
                sn: null,
                soft: null,
                timeStamp: null,
                vin: null
            },

            report: {

                status: null,
                val: []
            },

            installed: false
        },

        IMMO: {

            info: {

                calibration: null,
                fullName: 'Immobiliser',
                fw: null,
                hw: null,
                mileage: null,
                name: 'IMMO',
                sn: null,
                soft: null,
                timeStamp: null,
                vin: null
            },

            report: {

                status: null,
                val: []
            },

            installed: false
        },

        PTS: {

            info: {

                calibration: null,
                fullName: 'Parktronic System',
                fw: null,
                hw: null,
                mileage: null,
                name: 'PTS',
                sn: null,
                soft: null,
                timeStamp: null,
                vin: null
            },

            report: {

                status: null,
                val: []
            },

            installed: false
        },

        HVAC: {

            info: {

                calibration: null,
                fullName: 'Heating, Ventilation and Air Conditioning',
                fw: null,
                hw: null,
                mileage: null,
                name: 'HVAC',
                sn: null,
                soft: null,
                timeStamp: null,
                vin: null
            },

            report: {

                status: null,
                val: []
            },

            installed: false
        },

        ABS: {

            info: {

                calibration: null,
                fullName: 'Anti-lock Braking Systems',
                fw: null,
                hw: null,
                mileage: null,
                name: 'ABS',
                sn: null,
                soft: null,
                timeStamp: null,
                vin: null
            },

            report: {

                status: null,
                val: []
            },

            installed: false
        }
    })

    const ecusProcess   = ref(false)
    const ecusMsg       = ref({})
    const hasReport     = ref(false)

    async function readEcus(payload) {

        ecusProcess.value = true
        const token = tokenStore.access

        if(token) {
            
            let params = ''
            if(payload) {
                for( let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }
            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/reports/last${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error && request.array && request.array.length) {
                let didCnt = 0
                for(let ecu of request.array) {
                    let stateEcu = ecus.value[ecu.block]
                    if(stateEcu) {
                        stateEcu.info.callibration  = ecu.info.callibration
                        stateEcu.info.fw            = ecu.info.fw
                        stateEcu.info.hw            = ecu.info.hw
                        stateEcu.info.mileage       = ecu.info.mileage ? (ecu.info.mileage / 10).toFixed(1) : '–'
                        stateEcu.info.sn            = ecu.info.sn
                        stateEcu.info.soft          = ecu.info.soft
                        stateEcu.info.timeStamp     = ecu.tm
                        stateEcu.info.vin           = ecu.info.vin
                        stateEcu.installed          = true
                        stateEcu.report             = ecu.report
                        if(ecu.block !== 'GNSS') didCnt++
                    }
                }
                hasReport.value = didCnt
                ecusMsg.value = { success: true }
            } else {
                ecusMsg.value = { success: false, text: request.error }
            }

        } else {
            ecusMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        ecusProcess.value = false
    }

    const setEcusMsg = data => ecusMsg.value = data

    const resetEcus = () => {

        for(let ecuKey of Object.keys(ecus.value)) {

            for( let valueKey in ecus.value[ecuKey].info ) {
                const val = ecus.value[ecuKey]
                if(valueKey !== 'name' && valueKey !== 'fullName') {
                    val.info[valueKey] = null
                }
            }

            ecus.value[ecuKey].report = { 
                status: null, 
                val: [] 
            }

            ecus.value[ecuKey].installed = false
        }
    }

    return {

        ecus,
        ecusProcess,
        ecusMsg,
        hasReport,
        readEcus,
        setEcusMsg,
        resetEcus
    }
})
